import * as API from '../'
import $const from "../../common/constant";

export default {
  /**
   * 生成验证码
   */
  getDictionaryResolveToTree: params => {
    return API.GET($const.apiServer.Base + `/dictionary/getDictionaryResolveToTree`, params)
  },
  //根据编码获得下级区域
  getAreaByParentCode: params => {
    console.log(params)
    return API.GET($const.apiServer.Base + '/sysArea/getAreaByParentCode?parentCode=' + params.parentCode)
  },

  //根据编码获得下级行业
  getIndustryByParentCode: params => {
    console.log(params)
    return API.GET($const.apiServer.Base + '/dictionary/getListByParentCodes?parentCode=' + params.parentCode)
  },

}



// WEBPACK FOOTER //
// ./src/api/base/api_base.js